import { invoiceLineContribution } from "@common/helpers/invoice-line-allocation";
import { sumMonetaryValues } from "@common/helpers/monetary";

export interface ImportedSettlementIdentity {
    providerId: string | null;
    paymentDateOnly: string | null;
    cutoverDate: string;
}

export interface ImportedSettlementTotal extends ImportedSettlementIdentity {
    amount: number;
}

export interface ImportedSettlementRow extends ImportedSettlementIdentity {
    amount: number;
    lineKind: string | null;
}

export function groupImportedSettlementRows(
    rows: ImportedSettlementRow[],
): ImportedSettlementTotal[] {
    const settlementsByKey = new Map<string, ImportedSettlementTotal>();
    for (const row of rows) {
        const key = importedSettlementKey(row);
        const existing = settlementsByKey.get(key);
        settlementsByKey.set(key, {
            providerId: row.providerId,
            paymentDateOnly: row.paymentDateOnly,
            cutoverDate: row.cutoverDate,
            amount: sumMonetaryValues([
                existing?.amount ?? 0,
                invoiceLineContribution({
                    amount: row.amount,
                    kind: row.lineKind,
                }),
            ]),
        });
    }
    return [...settlementsByKey.values()].sort(compareSettlements);
}

export function importedSettlementKey(
    settlement: ImportedSettlementIdentity,
): string {
    return [
        settlement.paymentDateOnly ?? "",
        settlement.providerId ?? "",
        settlement.cutoverDate,
    ].join("|");
}

function compareSettlements(
    left: ImportedSettlementTotal,
    right: ImportedSettlementTotal,
): number {
    if (left.paymentDateOnly !== right.paymentDateOnly) {
        if (left.paymentDateOnly === null) {
            return 1;
        }
        if (right.paymentDateOnly === null) {
            return -1;
        }
        return left.paymentDateOnly < right.paymentDateOnly ? -1 : 1;
    }
    return importedSettlementKey(left).localeCompare(
        importedSettlementKey(right),
    );
}
